<template>
    <div class="content">
        <div style="position: relative;height: 85vh;">
            <div id="time-select">
                <el-radio-group v-model="timeSelect">
                    <el-radio-button label="全部时间"></el-radio-button>
                    <el-radio-button label="最近一月"></el-radio-button>
                    <el-radio-button label="最近一季度"></el-radio-button>
                    <el-radio-button label="最近一年"></el-radio-button>
                </el-radio-group>
            </div>
            <div id="area-avg-bar" ref="AvgBar"></div>
        </div>
    </div>
</template>

<script>
    import options from './../../../../utils/options'
    import echarts from 'echarts'
    import {getHostAvg} from "../../../../network/compileAnalysis";


    export default {
        name: "HostAvgv2",
        props: ['hostAvgData'],

        data() {
            return {
                chartBar: '',
                optionBar: options.optionAvgBar,
                dataInfo: [],
                legendSelectType: '全部',
                timeSelect: '全部时间',
                data: []
            }
        },

        methods: {
            chartInit() {
                this.chartBar = echarts.init(this.$refs.AvgBar);
                this.optionBar.xAxis.data = this.dataInfo.xAxis;
                // this.optionBar.series[0].name = '全部';
                // this.optionBar.series[0].data = this.dataInfo.yAxis_all;
                this.optionBar.series[0].name = '报告表';
                this.optionBar.series[0].data = this.dataInfo.yAxis_biao;
                this.optionBar.series[1].name = '报告书';
                this.optionBar.series[1].data = this.dataInfo.yAxis_shu;
                // console.log(this.dataInfo.baogaoshu)
                this.optionBar.series[2].data = [this.dataInfo.baogaoshu];
                this.optionBar.title.text = '各省编制主持人平均业绩情况';
                this.chartBar.hideLoading();
                this.chartBar.setOption(this.optionBar, true);
            },

            formatDate(val) {
                let yAxis_all = [];
                let yAxis_biao = [];
                let yAxis_shu = [];
                let xAxis = [];
                let baogaoshu = [];
                baogaoshu = val['全国']['baogaoshu'];
                // console.log(baogaoshu)
                let sortData = function () {
                    let result = [];
                    for (let data of val['各省']) {

                        result.push({name: data['compile_unit__province'], value: data['all_avg']})
                    }
                    return result
                }();
                sortData.sort((a, b) => b.value - a.value);

                for (let data of sortData) {
                    xAxis.push(data['name']);
                    yAxis_all.push(data['value'])
                }


                for (let data1 of sortData) {
                    for (let data2 of val['各省']) {
                        if (data1['name'] === data2['compile_unit__province']) {
                            yAxis_shu.push(data2['baogaoshu_avg'])
                            yAxis_biao.push(data2['baogaobiao_avg'])

                        }
                    }
                }
                return {
                    xAxis, yAxis_all, yAxis_biao, yAxis_shu, baogaoshu
                }
            },
        },

        watch: {
            hostAvgData: {
                handler(val){
                    this.data = val;
                },
                deep: true,
            },

            data: {
                handler(val){
                    if (val.hasOwnProperty('各省')) {
                        this.dataInfo = this.formatDate(val);
                        this.chartInit()
                    }
                },
                deep: true,
            },

            timeSelect(val) {
                this.chartBar.showLoading();
                getHostAvg(val).then(res => {
                    this.data = res.data.result
                })
            },
        },

    }

</script>

<style scoped>

    .content {

        height: 100vh;
        width: 1640px;
        /*background-color: #71a4d1;*/
        /*display: block;*/
    }

    #area-avg-bar {
        /*position: relative;*/
        width: 100%;
        height: 85vh;
        float: left;
        /*margin-left: 400px;*/
        /*margin-top: 30px;*/
        padding-top: 120px;
        /*background-color: #f7f7f7;*/
    }

    #time-select {
        position: relative;
        z-index: 999;
        /*left: 320px;*/
        top: 200px;
        margin-left: 180px;
        /*margin-right: auto;*/
    }

</style>